<template>
<div class="chapter">
<div class="inner_page">
<div>
<br/><br/><br/><br/>
<p class="title"><span style="font-size: 1.5em;">LEADERSHIP</span><br/>
COMPETENCIES THAT ENABLE RESULTS</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01-ht.vue?83b01230